import React, { useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import FolhaCelular from '../egora/FolhaCelular';
import { gruposVisiveis } from './navegacao';
import { abrirPerfil } from './perfil';
import './casca.css';

/** Os quatro atalhos da prancheta do celular. Cada um só aparece se a rota deixa abrir. */
const ATALHOS = [
  { rotulo: 'Início', icone: 'home', rota: '/' },
  { rotulo: 'Agenda', icone: 'calendar_month', rota: '/agenda' },
  { rotulo: 'Processos', icone: 'folder_open', rota: '/juridico', permissao: 'juridico' },
  { rotulo: 'Clientes', icone: 'groups', rota: '/crm', permissao: 'crm' },
];

/**
 * Celular (Home.dc.html): barra inferior com 4 atalhos e "Mais". "Mais" abre a
 * folha com todos os módulos em blocos de três, Configurações, o perfil e Sair.
 * Só aparece abaixo de 820 px (egora.css).
 */
export default function BarraInferior() {
  const { usuarioLogado, temPermissao, logout } = useAuth();
  const { pathname } = useLocation();
  const [maisAberto, setMaisAberto] = useState(false);

  const grupos = useMemo(() => gruposVisiveis(temPermissao, usuarioLogado), [temPermissao, usuarioLogado]);
  const atalhos = ATALHOS.filter((a) => !a.permissao || temPermissao(a.permissao));
  const gruposDaFolha = grupos.filter((g) => g.id !== 'configuracoes');
  const configuracoes = grupos.find((g) => g.id === 'configuracoes');

  const fechar = () => setMaisAberto(false);
  const atual = (rota) => (rota === '/' ? pathname === '/' : pathname === rota || pathname.startsWith(`${rota}/`));

  return (
    <>
      <nav className="sj-barra-inferior" aria-label="Principal no celular">
        {atalhos.map((a) => (
          <NavLink key={a.rota} to={a.rota} aria-current={atual(a.rota) ? 'page' : undefined}>
            <span className="sj-icone" aria-hidden="true">{a.icone}</span>
            {a.rotulo}
          </NavLink>
        ))}
        <a
          href="#mais"
          role="button"
          aria-haspopup="dialog"
          aria-expanded={maisAberto}
          onClick={(e) => { e.preventDefault(); setMaisAberto(true); }}
        >
          <span className="sj-icone" aria-hidden="true">menu</span>
          Mais
        </a>
      </nav>

      <FolhaCelular aberto={maisAberto} onFechar={fechar} titulo="Todos os módulos">
        <div className="casca-folha">
          {gruposDaFolha.map((grupo) => (
            <section key={grupo.id} className="casca-folha__grupo" aria-label={grupo.rotulo}>
              <h3 className="casca-folha__rotulo">{grupo.rotulo}</h3>
              <div className="casca-folha__grade">
                {grupo.modulos.map((m) => (
                  <NavLink key={m.rota} to={m.rota} className="casca-folha__bloco" onClick={fechar} aria-current={atual(m.rota) ? 'page' : undefined}>
                    {m.rotulo}
                  </NavLink>
                ))}
              </div>
            </section>
          ))}

          {configuracoes && configuracoes.modulos.map((m) => (
            <NavLink key={m.rota} to={m.rota} className="casca-folha__linha" onClick={fechar}>
              <span className="sj-icone" aria-hidden="true">{m.rota === '/configuracoes' ? 'settings' : m.icone}</span>
              {m.rotulo}
            </NavLink>
          ))}
          <a href="#perfil" className="casca-folha__linha" onClick={(e) => { e.preventDefault(); fechar(); abrirPerfil(); }}>
            <span className="sj-icone" aria-hidden="true">person</span>
            Ver perfil de {usuarioLogado.nome}
          </a>
          <a href="#sair" className="casca-folha__linha" onClick={(e) => { e.preventDefault(); fechar(); logout(); }}>
            <span className="sj-icone" aria-hidden="true">logout</span>
            Sair
          </a>
        </div>
      </FolhaCelular>
    </>
  );
}
